import { PermissionRequestPage } from './permission-request';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FlxCommonsModule } from "@questrade/flx-commons";

@NgModule({
    declarations: [
        PermissionRequestPage,
    ],
    imports: [
        FlxCommonsModule,
        IonicPageModule.forChild(PermissionRequestPage),
    ],
    exports: [
        PermissionRequestPage
    ]
})
export class PermissionRequestModule { }



// WEBPACK FOOTER //
// ./src/pages/permission-request/permission-request.module.ts